module.exports = "pegasus/assets/styleGroup2-youtube.png";